var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.4C2 4.07452 3.07452 3 4.4 3H4.5C4.77614 3 5 3.22386 5 3.5C5 3.77614 4.77614 4 4.5 4H4.4C3.6268 4 3 4.6268 3 5.4V5.6C3 6.3732 3.6268 7 4.4 7H4.5C4.77614 7 5 7.22386 5 7.5C5 7.77614 4.77614 8 4.5 8H4.4C3.07452 8 2 6.92548 2 5.6V5.4ZM10 5.4C10 4.07452 8.92548 3 7.6 3H7.5C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4H7.6C8.3732 4 9 4.6268 9 5.4V5.6C9 6.3732 8.3732 7 7.6 7H7.5C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H7.6C8.92548 8 10 6.92548 10 5.6V5.4ZM4.5 5C4.22386 5 4 5.22386 4 5.5C4 5.77614 4.22386 6 4.5 6H7.5C7.77614 6 8 5.77614 8 5.5C8 5.22386 7.77614 5 7.5 5H4.5Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8ff5f05c235575fab65a5827b981ad2f.svg";
export { ForwardRef as ReactComponent };